import CategoryRounded from "@mui/icons-material/CategoryRounded";
import Inventory2Rounded from "@mui/icons-material/Inventory2Rounded";
import { Grid, Paper, Typography } from "@mui/material";

interface Props {
  totalProducts: number;
  totalCategories: number;
}

export default function StatsCards({ totalProducts, totalCategories }: Props) {
  return (
    <Grid container spacing={2} mb={3}>
      <Grid item xs={12} md={6}>
        <Paper
          elevation={0}
          sx={{
            borderRadius: 1,
            p: 2.5,
            display: "flex",
            alignItems: "center",
            gap: 2,
            border: "1px solid",
            borderColor: "divider",
          }}
        >
          <Inventory2Rounded color="primary" />
          <div>
            <Typography variant="body2" color="text.secondary">
              Total productos
            </Typography>
            <Typography variant="h5" fontWeight={700}>
              {totalProducts}
            </Typography>
          </div>
        </Paper>
      </Grid>

      <Grid item xs={12} md={6}>
        <Paper
          elevation={0}
          sx={{
            borderRadius: 1,
            p: 2.5,
            display: "flex",
            alignItems: "center",
            gap: 2,
            border: "1px solid",
            borderColor: "divider",
          }}
        >
          <CategoryRounded color="secondary" />
          <div>
            <Typography variant="body2" color="text.secondary">
              Total categorías
            </Typography>
            <Typography variant="h5" fontWeight={700}>
              {totalCategories}
            </Typography>
          </div>
        </Paper>
      </Grid>
    </Grid>
  );
}
